import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { trpc } from "../../app/trpc.js";
import { Notice, PageTitle, Spinner } from "../../ui/index.js";
import { useCabinet } from "../cabinet/index.js";
import { ShareLinks } from "./ShareLinks.js";

/** «Ещё → Страница записи и QR»: тот же итог, что в конце мастера настройки. Только владелец. */
export function BookingLinkPage() {
  const { t } = useTranslation();
  const cab = useCabinet();
  const state = useQuery(trpc.onboarding.state.queryOptions({ salonId: cab.salonId }, { enabled: Boolean(cab.salonId) }));
  if (state.isPending) return <Spinner />;
  if (!state.data) return <Notice kind="error">{t("common.error")}</Notice>;
  return (
    <div>
      <PageTitle>{t("onb.links.title")}</PageTitle>
      <ShareLinks
        bookingUrl={state.data.bookingUrl}
        noticeUrl={state.data.noticeUrl}
        salonName={state.data.salonName}
        closed={state.data.bookingClosed}
        billingPath={`${cab.base}/billing`}
      />
    </div>
  );
}
